import { render, staticRenderFns } from "./SamInfoBlock.vue?vue&type=template&id=5cbdcd0d&scoped=true&"
import script from "./SamInfoBlock.vue?vue&type=script&lang=js&"
export * from "./SamInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./SamInfoBlock.vue?vue&type=style&index=0&id=5cbdcd0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbdcd0d",
  null
  
)

export default component.exports